var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnownMissingFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7101 6.87906L25.124 10.293L23.7098 11.7072L20.2959 8.29327L21.7101 6.87906Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2957 6.87485L11.71 8.28906L8.29605 11.703L6.88183 10.2888L10.2957 6.87485Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87998 19.7031L2.58598 17.4091C2.20898 17.0321 2.00098 16.5301 2.00098 15.9961C2.00098 15.4621 2.20898 14.9601 2.58598 14.5831L4.87998 12.2891L6.29398 13.7031L3.99998 15.9971L6.29398 18.2891L4.87998 19.7031Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29019 20.2892L11.7041 23.7031L10.2899 25.1173L6.87597 21.7034L8.29019 20.2892Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.0039C15.466 30.0039 14.964 29.7959 14.587 29.4189L12.293 27.1249L13.707 25.7109L16.001 28.0039L18.293 25.7109L19.707 27.1249L17.413 29.4189C17.036 29.7959 16.534 30.0039 16 30.0039Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.99609C15.466 1.99609 14.964 2.20409 14.587 2.58109L12.293 4.87509L13.707 6.28909L16.001 3.99609L18.293 6.28909L19.707 4.87509L17.413 2.58109C17.036 2.20409 16.534 1.99609 16 1.99609Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7059 20.2967L25.1201 21.7109L21.7062 25.1249L20.292 23.7106L23.7059 20.2967Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1201 19.7031L25.7061 18.2891L28.0001 15.9951L25.7061 13.7031L27.1201 12.2891L29.4141 14.5831C29.7911 14.9601 29.9991 15.4621 29.9991 15.9961C29.9991 16.5301 29.7911 17.0321 29.4141 17.4091L27.1201 19.7031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnownMissingFeatures);
export default __webpack_public_path__ + "static/media/known-missing-features.0a4b4085c8b94e5b3c853e7af0c7ad29.svg";
export { ForwardRef as ReactComponent };